// src/utils/wx.js
import Vue from 'vue'

export default {
  startPullDownRefresh () {
    console.log('startPullDownRefresh')
  },
  showLoading () {
    Vue.prototype.$loading('加载中')
  },
  hideLoading () {
    if (!document.querySelector('.lx-load-mark')) return
    Vue.prototype.$loading.close()
  },
  showToast ({title}) {
    Vue.prototype.$toast.center(title)
  }
}



// WEBPACK FOOTER //
// ./src/utils/wx.js